import { initLiveList } from '../../shared/liveList.js';

// The radius search on the customer's Karte section: its filter row, wired to
// refetch the results region rather than reload the page.
//
// Its own module rather than part of kundeKarte.js, because the two have
// different preconditions. The table renders whenever the customer has a
// geocoded point; the map additionally needs MAPBOX_PUBLIC_TOKEN. Folding them
// together would mean the list stopped filtering on an installation with no
// browser token - a configuration problem turning into a data one.
//
// The markers are not this module's business: kundeKarte.js watches the same
// region and redraws them from the payload the server sends with each
// fragment, so there is nothing to coordinate here.
export function initKundeUmkreis() {
  // The list's own URL is this page's, which already carries the customer id.
  // Read off the location rather than a data attribute: replaceState keeps it
  // correct as filters change, and the redirect guard inside liveList compares
  // pathnames.
  initLiveList({
    results: 'kandidaten-umkreis',
    path: window.location.pathname,
    forms: ['umkreis-filter']
  });
}
